"use client";

import { useAuth } from "@/hooks/use-auth";
import { usePathname } from "next/navigation";
import type { ReactNode } from "react";
import AuthLoading from "./loading";
import MeetingReminderBanner from "@/components/MeetingReminderBanner";
import FeatureBoundary from "@/components/FeatureBoundary";

const PUBLIC_PATHS = ["/public/note/", "/form/public/", "/capture/", "/privacy", "/terms"];

export default function ProtectedLayout({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();
  const pathname = usePathname();

  const isPublicRoute = PUBLIC_PATHS.some((p) => pathname?.startsWith(p));

  if (isPublicRoute) {
    return <>{children}</>;
  }

  if (isLoading) {
    return <AuthLoading />;
  }

  // If not authenticated, the auth provider will redirect to login
  // This is just a fallback in case something goes wrong
  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      {children}
      <FeatureBoundary name="meeting-reminder-banner" fallback={null}>
        <MeetingReminderBanner />
      </FeatureBoundary>
    </>
  );
}
